import { CustomerDetailFragment, CustomerInput, CustomerType } from 'src/api/api.generated'
import { GuestOccupancy } from '../types/guests.types'
import { emptyGuestOccupancy, fragmentToCustomer } from '../utils/guests.utils'
import { Customer, GuestFields, UpdateCustomerAndGuestOccupancyInput } from './update-reserved-resource-guests.types'

export function fragmentToModel(f: CustomerDetailFragment | undefined): Customer | undefined {
  if (f === undefined) return undefined
  return fragmentToCustomer(f)
}

export function modelToInput(tenantId: string, m: GuestFields): CustomerInput {
  return {
    tenantId,
    type: CustomerType.PERSON,
    name: `${m.lastName} ${m.firstName}`,
    language: m.language,
    firstName: m.firstName,
    lastName: m.lastName,
    person: {
      gender: m.gender,
      birthDate: m.birthDate,
      birthAddress: m.birthAddress
        ? {
            countryId: m.birthAddress.countryId,
            municipalityId: m.birthAddress.municipalityId,
            province: m.birthAddress.province,
            city: m.birthAddress.city,
          }
        : null,
      nationalityId: m.nationalityId,
      identificationDocument: m.identificationDocument,
    },
    address: m.address
      ? {
          countryId: m.address.countryId,
          municipalityId: m.address.municipalityId,
          province: m.address.province,
          city: m.address.city,
        }
      : null,
  }
}

export function inputToOutput(input: UpdateCustomerAndGuestOccupancyInput, customer: Customer | undefined): GuestOccupancy {
  switch (input.operation) {
    case 'CLEAR':
      return emptyGuestOccupancy()
    case 'ASSIGN':
      if (customer) {
        return {
          ...input.occupancy,
          phase: null,
          ...customer,
          guestId: customer.id,
          checkin: null,
          checkout: null,
        }
      } else {
        return {
          ...input.occupancy,
          phase: null,
          ...input.guest,
          guestId: input.guest.id,
          checkin: null,
          checkout: null,
        }
      }
    case 'UPDATE':
      if (customer) {
        return {
          ...input.occupancy,
          phase: null,
          ...customer,
          guestId: customer.id,
          checkin: null,
          checkout: null,
        }
      } else {
        return {
          ...input.occupancy,
          phase: null,
          ...input.guest,
          guestId: input.guest.id,
          checkin: null,
          checkout: null,
        }
      }
    case 'CREATE':
      if (customer) {
        return {
          ...input.occupancy,
          phase: null,
          ...customer,
          guestId: customer.id,
          checkin: null,
          checkout: null,
        }
      } else {
        return {
          ...input.occupancy,
          phase: null,
          ...input.guest,
          guestId: null,
          checkin: null,
          checkout: null,
        }
      }

    default:
      return emptyGuestOccupancy()
  }
}
